import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellOrderStatusBar, { SellOrderStatusBarNew, SellOrderStatusBarProps } from '../../../SellOrderStatusBar'
import SellOrderCreateNoPermissionButtons, { SellOrderCreateNoPermissionButtonsNew } from '../SellOrderCreateNoPermissionButtons'

type SellOrderCreateNoPermissionStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellOrderCreateNoPermissionStepHeaderDecider: React.FC<SellOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellOrderCreateNoPermissionStepHeaderDefault} NewComponent={SellOrderCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const SellOrderCreateNoPermissionStepHeaderDefault: React.FC<SellOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellOrderStatusBar {...rest} />
            <SellOrderCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const SellOrderCreateNoPermissionStepHeaderNew: React.FC<SellOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellOrderStatusBarNew {...rest} />
            <SellOrderCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellOrderCreateNoPermissionStepHeaderDecider